import { ProductType } from "@/shared/types/enums";

export const getProductTypeLabel = (type: ProductType): string => {
  const labels: Record<ProductType, string> = {
    [ProductType.JACKET]: "Paletó",
    [ProductType.VEST]: "Colete",
    [ProductType.GOWN]: "Beca",
    [ProductType.PANTS]: "Calça",
  };
  return labels[type] || type;
};

export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result as string;
      const base64Data = base64String.split(",")[1];
      resolve(base64Data);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const fileToBase64WithPrefix = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result as string);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const isValidImageFile = (file: File): boolean => {
  return file.type.startsWith("image/");
};

export const isValidFileSize = (file: File, maxSizeInMB: number): boolean => {
  const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
  return file.size <= maxSizeInBytes;
};
